import { render, staticRenderFns } from "./EfsStdFarmerStandardModal.vue?vue&type=template&id=a72ccf16&scoped=true&"
import script from "./EfsStdFarmerStandardModal.vue?vue&type=script&lang=js&"
export * from "./EfsStdFarmerStandardModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a72ccf16",
  null
  
)

export default component.exports